import { render, staticRenderFns } from "./UmfChart.vue?vue&type=template&id=41dfb4a6&"
import script from "./UmfChart.vue?vue&type=script&lang=js&"
export * from "./UmfChart.vue?vue&type=script&lang=js&"
import style0 from "./UmfChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports